import {
  Goal,
  Language,
  Modalities,
  Scholarity,
  Seniority,
} from '@/models/recommendation';

export const GoalLabels = {
  [Goal.CareerDevelopment]: 'Evoluir na carreira',
  [Goal.CareerChange]: 'Mudança de carreira',
};

export const LanguageLabels = {
  [Language.French]: 'Francês',
  [Language.English]: 'Inglês',
  [Language.Mandarin]: 'Mandarim',
  [Language.Spanish]: 'Espanhol',
  [Language.Italian]: 'Italiano',
  [Language.Japanese]: 'Japonês',
  [Language.German]: 'Alemão',
  [Language.Korean]: 'Coreano',
  [Language.Portuguese]: 'Português para estrangeiros',
};

export const ScholarityLabels = {
  [Scholarity.HighSchoolIncomplete]: 'Ensino Médio incompleto',
  [Scholarity.HighSchoolComplete]: 'Ensino Médio completo',
  [Scholarity.UndergraduateIncomplete]: 'Ensino Superior incompleto',
  [Scholarity.UndergraduateComplete]: 'Ensino Superior completo',
  [Scholarity.Postgraduate]: 'Pós-Graduação/Mestrado/MBA',
  [Scholarity.Doctoral]: 'Doutorado/Pós-Doutorado',
};

export const SeniorityLabels = {
  [Seniority.Apprentice]: 'Jovem aprendiz',
  [Seniority.Intern]: 'Estagiário',
  [Seniority.Attendant]: 'Atendente',
  [Seniority.Operator]: 'Operador',
  [Seniority.Technician]: 'Técnico',
  [Seniority.Auxiliary]: 'Auxiliar',
  [Seniority.Assistant]: 'Assistente',
  [Seniority.Analyst]: 'Analista',
  [Seniority.Supervisor]: 'Supervisor',
  [Seniority.Coordinator]: 'Coordenador',
  [Seniority.Specialist]: 'Especialista',
  [Seniority.Manager]: 'Gerente',
  [Seniority.Director]: 'Diretor',
  [Seniority.VicePresident]: 'Vice presidente/Presidente',
};

export const ModalitiesLabels = {
  [Modalities.Hybrid]: 'Híbrido',
  [Modalities.Presencial]: 'Presencial',
  [Modalities.Distance]: 'A distância',
};
